// TabBar
import React, { PropsWithChildren } from 'react';
import styles from './TabBar.module.sass';
import { OptionValue } from 'types/common';
import cn from 'classnames';
import Dropdown from '../Dropdown';

export interface TabBarProps<T extends string> {
  selected: T | undefined;
  tabs: OptionValue<T>;
  onTabSelect: (value: T) => void;
  className?: string;
}

const TabBar = <P extends string>({
  tabs,
  selected,
  onTabSelect,
  className,
}: PropsWithChildren<TabBarProps<P>>): JSX.Element => {
  return (
    <div className={cn(styles.tabBar, className)}>
      <div className={styles.dropdownContainer}>
        <Dropdown
          value={selected}
          options={tabs}
          setValue={onTabSelect}
          classDropdownHead={styles.dropdown}
          classDropdownSelection={styles.dropdownSelection}
          classMenu={styles.dropdownMenu}
        />
      </div>
      <div className={styles.tabsContainer}>
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            active={selected === tab.value}
            label={tab.label}
            onClick={() => onTabSelect(tab.value)}
          />
        ))}
      </div>
    </div>
  );
};

export default TabBar;

const Tab: React.FC<{
  active: boolean;
  label: string;
  onClick: () => void;
}> = ({ active, label, onClick }) => (
  <div
    onClick={onClick}
    className={cn(styles.tab, {
      [styles.active]: active,
    })}
  >
    <p>{label}</p>
  </div>
);
